module.exports = {
  pin: {
    sandbox: true,
    publishable_api_key: process.env.REACT_APP_PIN_PUBLIC_KEY,
  },
  recaptcha: {
    site_key: "6LcenwEiAAAAAK8biCJI7pbwD3X6_AdnYz3u5y-G",
  },
};
